
import type { Map } from 'leaflet'

interface Point {
  latitude: number
  longitude: number
}

const toRadians = (degree: number) => (degree * Math.PI) / 180
export const calculateDistanceBetweenTwoPoints = (pointA: Point, pointB: Point): number => {
  // Promień Ziemi w kilometrach
  const R = 6371
  const latDistance = toRadians(pointB.latitude - pointA.latitude)
  const lonDistance = toRadians(pointB.longitude - pointA.longitude)
  const a = Math.sin(latDistance / 2) ** 2 +
    Math.cos(toRadians(pointA.latitude)) * Math.cos(toRadians(pointB.latitude)) *
    Math.sin(lonDistance / 2) ** 2
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  // Odległość w kilometrach
  return R * c
}

export const getMapBoundsAndMapCenter = (map: Map) => {
  const mapCenter = map.getCenter()
  const mapBounds = map.getBounds()
  const center: delivery.Coordinates = {
    latitude: mapCenter.lat,
    longitude: mapCenter.lng
  }
  const bounds: delivery.BodyMapBounds = {
    north_west: {
      latitude: mapBounds.getNorth(),
      longitude: mapBounds.getWest()
    },
    north_east: {
      latitude: mapBounds.getNorth(),
      longitude: mapBounds.getEast()
    },
    south_west: {
      latitude: mapBounds.getSouth(),
      longitude: mapBounds.getWest()
    },
    south_east: {
      latitude: mapBounds.getSouth(),
      longitude: mapBounds.getEast()
    }
  }
  return {
    center,
    bounds
  }
}

export const getMapDistanceAndMapCenter = (map: Map) => {
  const mapCenter = map.getCenter()
  const mapBounds = map.getBounds()
  const center: Point = {
    latitude: mapCenter.lat,
    longitude: mapCenter.lng
  }
  const pointCenterWest: Point = {
    latitude: mapCenter.lat,
    longitude: mapBounds.getWest()
  }
  const pointCenterEast: Point = {
    latitude: mapCenter.lat,
    longitude: mapBounds.getEast()
  }
  const distance = calculateDistanceBetweenTwoPoints(pointCenterEast, pointCenterWest)
  return {
    center,
    distance
  }
}